import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';

import {
    lightBlue,
    amber,
    orange,
    green,
    grey,
    lightGreen,
    red,
    yellow
} from '@material-ui/core/colors';

const styles = {
    green: {
        backgroundColor: green[500],
        color: '#FFFFFF',
    },
    yellow: {
        backgroundColor: yellow[500],
        color: '#000000',
    },
    red: {
        backgroundColor: red[500],
        color: '#FFFFFF'
    },
};

const renderTimeSinceRequestedChip = (value, isBlueRoof) => {
    let minutesOrHours = 'Hours';
    let adjustedTime = value;

    const [yellowValue, redValue] = !isBlueRoof ? [2, 4] : [15, 22];
    
    if (value < 1) {
        minutesOrHours = "Minutes";
        adjustedTime = Math.round(value * 60);
    }

    const label = `${adjustedTime} ${minutesOrHours}`;

    let style = 'green';

    if (value > yellowValue && value < redValue)
        style = 'yellow';

    if (value >= redValue)
        style = 'red';

    return (<Chip label={label} style={styles[style]} />);
}

const TimeSinceRequestedChip = props => renderTimeSinceRequestedChip(props.value, props.isBlueRoof);

TimeSinceRequestedChip.propTypes = {
    value: PropTypes.number,
    isBlueRoof: PropTypes.bool,
};

TimeSinceRequestedChip.defaultProps = {
    value: null,
    isBlueRoof: false,
};

export default TimeSinceRequestedChip;
